import { Component, Input, OnInit } from '@angular/core';
import * as moment from 'moment';

import { Training, GraphQlService } from '../../../../_services';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'training-detail-evaluation',
    templateUrl: './evaluation.component.html',
    styleUrls: [
        '../../training.component.scss',
        '../detail.component.scss',
        './evaluation.style.scss',
    ],
    providers: [TranslatePipe],
})
export class TrainingDetailEvaluationComponent implements OnInit {
    @Input() training: any;
    pastSessions: any[] = [];
    futureSessions: any[] = [];
    evaluations: any = { aggregate: { averages: {} } };
    maxEvaluations = 100;
    maxPastSessions = 30;
    maxFutureSessions = 5;

    constructor(private graphQlService: GraphQlService) {}

    ngOnInit() {
        this.getEvaluations();
    }

    getEvaluations() {
        this.graphQlService
            .post({
                query: `
                    query(
                        $trainingId: bigint!
                        $maxEvaluations: Int!
                        $maxPastSessions: Int!
                        $maxFutureSessions: Int!
                        $now: date!
                    ) {
                        evaluations: student_evaluation_aggregate(
                            where: {
                                deleted: { _eq: false }
                                training_session: {
                                    deleted: { _eq: false }
                                    training_session_training: { training_id: { _eq: $trainingId } }
                                }
                            }
                            order_by: { training_session: { start_date: desc } }
                            limit: $maxEvaluations
                        ) {
                            aggregate {
                                count
                                averages: avg {
                                    layout: training_layout
                                    examples: training_examples
                                    contentRichness: training_content_richness
                                    practiceInterest: training_practice_interest
                                    theoryPracticeRatio: training_theory_practice_ratio
                                }
                            }
                        }
                        pastSessions: training_session(
                            where: {
                                deleted: { _eq: false }
                                training_session_training: { training_id: { _eq: $trainingId } }
                                end_date: { _lt: $now }
                            }
                            order_by: { start_date: desc }
                            limit: $maxPastSessions
                        ) {
                            id
                            startDate: start_date
                            trainer {
                                firstName: first_name
                                lastName: last_name
                            }
                            evaluations: student_evaluations_aggregate(
                                where: { deleted: { _eq: false } }
                            ) {
                                aggregate {
                                    count
                                    averages: avg {
                                        layout: training_layout
                                        examples: training_examples
                                        contentRichness: training_content_richness
                                        practiceInterest: training_practice_interest
                                        theoryPracticeRatio: training_theory_practice_ratio
                                    }
                                }
                            }
                        }
                        futureSessions: training_session(
                            where: {
                                deleted: { _eq: false }
                                training_session_training: { training_id: { _eq: $trainingId } }
                                end_date: { _gte: $now }
                            }
                            order_by: { start_date: asc }
                            limit: $maxFutureSessions
                        ) {
                            id
                            startDate: start_date
                            trainer {
                                firstName: first_name
                                lastName: last_name
                            }
                        }
                    }
                `,
                variables: {
                    trainingId: this.training.id,
                    maxEvaluations: this.maxEvaluations,
                    maxPastSessions: this.maxPastSessions,
                    maxFutureSessions: this.maxFutureSessions,
                    now: new Date().toISOString(),
                },
                role: 'world',
            })
            .subscribe(({ evaluations, pastSessions, futureSessions }) => {
                this.evaluations = evaluations;
                this.pastSessions = pastSessions;
                this.futureSessions = futureSessions;
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/_screens/training/detail/evaluation/evaluation.component.ts